<template>
  <div
    v-if="!isLoading && $attrs.value"
  >
    <div
      class="help-dialog elevation-3 rounded white px-4 py-2 ml-3 my-5"
    >
      <pp-button
        type="icon"
        class="help-dialog__btn-close elevation-3 white"
        icon="close"
        @click="closeDialog"
      />
      <p class="my-auto pt-2">
        {{ dialogTitle }} <br>
        {{ dialogDescription }}
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { HELP_DIALOG, WIDGET_CLICKED_SESSION_KEY } from '@/constants'
export default {
  name: 'HelpDialog',
  data () {
    return {
      dialogTitle: HELP_DIALOG.title,
      dialogDescription: HELP_DIALOG.description
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
      isLoading: 'isLoading'
    })
  },
  mounted () {
    /// check if the user already clicked the dialog within the same session and don't show
    const multiChannelSessionKey = sessionStorage.getItem(WIDGET_CLICKED_SESSION_KEY)
    if (!multiChannelSessionKey || multiChannelSessionKey === 'false') {
      if (this.isMobile) {
        this.$emit('input', true)
      } else {
        this.setIsWidgetOpen(true)
      }
    }
  },
  methods: {
    ...mapMutations({
      setIsWidgetOpen: 'SET_IS_WIDGET_OPEN'
    }),
    trackCloseHelpDialog () {
      this.$ppAnalytics.trackEvent({
        action: 'multi_channel_help_close'
      })
    },
    closeDialog () {
      this.$emit('input', false)
      sessionStorage.setItem(WIDGET_CLICKED_SESSION_KEY, true)
      this.trackCloseHelpDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
.help-dialog {
  min-width: 150px;

  &__btn-close {
    height: 32px;
    left: 10px;
    position: absolute;
    top: 3px;
    width: 32px;
  }
}
</style>
